module.exports = __webpack_public_path__ + "static/media/xcryo_new.b5380122.jpeg";